import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { api } from '../../api';
import { sentryLogError } from '../../utils';

import type { TCreateThunkApi } from './models';
import { setErrorStep, setRequestCodeWord, setUserStatus } from './application';

/** Запрос на получение данных надо ли предлагать брокерский счёт и кодове слово */
export const draftCheckRequest = createAsyncThunk<void, undefined, TCreateThunkApi>(
    'draftCheckRequest',
    async (_, { dispatch, getState }) => {
        const {
            application: { appId, businessUid },
        } = getState();

        try {
            const { data } = await api.draftsCheck({
                appId,
                businessUid,
            });

            dispatch(setUserStatus(data.userStatus));
            dispatch(setRequestCodeWord(data.requestCodeWord));
        } catch (error) {
            sentryLogError({
                error,
                message: 'applicationsDraftsCheck error',
                data: { appId, businessUid },
            });

            /* istanbul ignore if */
            if (!axios.isAxiosError(error)) {
                dispatch(setErrorStep());

                return;
            }

            dispatch(setErrorStep(error?.response?.data?.status));
        }
    }
);
